import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Text, useToast } from "@chakra-ui/react";
import { organizationQuestionnaireKeys } from "../../../../../../hooks/query";
import { FormInput } from "components/Forms";
import CategoryForm from "./CategoryForm";
import { useQueryClient } from "react-query";
import { useCreateUpstreamLeasedAssetsCategory, useUpdateUpstreamLeasedAssetsCategory } from "hooks/query/scope-3";
import { showErrorToast, showSuccessToast, translateSubElementString } from "../../../../../../utils";

function CategoryUpstreamLeasedAssets({ defaultValues, tabKey, handleCategoryChange, finalize, finalizeQuestionnaire }) {
	const toast = useToast();
	const queryClient = useQueryClient();
	const { id: questionnaireId, categories: { upstreamLeasedAssets: { co2Emission, id: categoryId } } } = defaultValues;
	const { t } = useTranslation("translation", {
		keyPrefix: "organizationQuestionnaire.scope3",
	});

	const upstreamLeasedAssetsDefaultValues = {
		co2Emission: co2Emission ?? "",
	};

	const {
		register,
		handleSubmit,
		formState: { errors, isDirty },
	} = useForm({
		defaultValues: upstreamLeasedAssetsDefaultValues,
	});

	const formId = `formStep${tabKey}`;

	const queryConfig = {
		onSuccess: () => {
			showSuccessToast(toast, "Category Upstream Leased Assets saved!");
			if (finalize) {
				finalizeQuestionnaire(questionnaireId);
			} else {
				queryClient.invalidateQueries(organizationQuestionnaireKeys.orgQuestionnaireById());
				if (!isLoadingOnCreate && !isLoadingOnUpdate) {
					handleCategoryChange();
				}
			}
		},
		onError: err => {
			showErrorToast(toast, err.message);
		}
	};

	const { mutate: create, isLoading: isLoadingOnCreate } = useCreateUpstreamLeasedAssetsCategory(queryConfig);
	const { mutate: update, isLoading: isLoadingOnUpdate } = useUpdateUpstreamLeasedAssetsCategory(queryConfig);

	const onSubmit = ((data) => {
		if (isDirty) {
			categoryId
				? update({ questionnaireId, id: categoryId, data })
				: create({ questionnaireId, data });
		} else {
			finalize ? finalizeQuestionnaire(questionnaireId) : handleCategoryChange();
		}
	});

	return (
		<CategoryForm onSubmit={handleSubmit(onSubmit)} id={formId}>
			<FormInput
				label={translateSubElementString(`organizationQuestionnaire.scope3.inputs.${tabKey}`)}
				type="number"
				errors={errors}
				{...register("co2Emission")}
				isDisabled={true}
			/>
		</CategoryForm>
	);
}

export default CategoryUpstreamLeasedAssets;
